import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import { IconButton, Stack } from "@mui/material";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import { useClientPermissionsContext } from "@entrilia/shared/contexts/ClientPermissionsContext";
import type { WorkbookRun } from "../../../../api/types/workbookRuns.types";
import { isDownloadableRun, isFinishedStatus } from "./workbookRunUtils";

interface Props {
  workbookRun: WorkbookRun;
  cancelingIds: string[];
  downloadingIds: string[];
  onDownload: () => void;
  onCancel: () => void;
  onDelete: () => void;
}

const WorkbookRunsGridActionCell = ({
  workbookRun,
  cancelingIds,
  downloadingIds,
  onDownload,
  onCancel,
  onDelete,
}: Props) => {
  const { hasAnyPermission } = useClientPermissionsContext();

  const isDownloadable = isDownloadableRun(workbookRun);
  const isFinished = isFinishedStatus(workbookRun.status);
  const isDownloading = downloadingIds.includes(workbookRun.id);

  return (
    <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
      {isDownloadable && (
        <IconButton onClick={onDownload} disabled={isDownloading}>
          <SaveAltRoundedIcon />
        </IconButton>
      )}
      {!isFinished && (
        <IconButton color="error" onClick={onCancel} disabled={cancelingIds.includes(workbookRun.id)}>
          <CloseRoundedIcon />
        </IconButton>
      )}
      <ActionsMenuButton
        items={[
          {
            label: "Download",
            icon: <SaveAltRoundedIcon />,
            onClick: onDownload,
            disabled: !isDownloadable || isDownloading,
            tooltip: isDownloadable ? undefined : "This run has no workbook to download yet",
          },
          {
            label: "Delete",
            icon: <DeleteOutlineRoundedIcon color="error" />,
            onClick: onDelete,
            disabled: !isFinished,
            tooltip: isFinished ? undefined : "Cancel the run before deleting it",
            hidden: !hasAnyPermission(["ManageReports"]),
          },
        ]}
      />
    </Stack>
  );
};

export default WorkbookRunsGridActionCell;
